import { gql } from '@apollo/client'

export type {
  RequestPasswordChange,
  RequestPasswordChangeVariables,
} from './types/RequestPasswordChange'

export const REQUEST_PASSWORD_CHANGE = gql`
  mutation RequestPasswordChange($email: String!) {
    requestPasswordChange(email: $email) {
      success
    }
  }
`
